// This Function Convert 24 hour Time into 12 Hour time 
const StringToTime = (props) => {
    const timeString12hr = new Date('1970-01-01T' + props + 'Z')   // Here you can use any Date, it will not 
        .toLocaleTimeString({},                                            // affect the code , the purpose of code is 
            { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }   //Just to return the time
        );
    return timeString12hr;
};

// This Function Convert Date time(24 hr) into Date time(12 hr).
const ReadableDateTime = (dateTime) => {
    if (!dateTime) return '';
    const timeString12hr = new Date(dateTime).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' });
    // console.log(timeString12hr);
    return timeString12hr;
};

// Wil give you This("August 16, 2023") From This("2023-08-16T00:00:00.000000Z")
const ReadableDate = (dateTime) => {
    const formattedDate = new Date(dateTime);
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    const readableDate = formattedDate.toLocaleDateString('en-US', options);
    // console.log(readableDate); // Output: August 16, 2023
    return readableDate;
};


const CurrentDate = () => {
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();

    var newDate = year + "-" + month + "-" + day;
    return newDate;
};

const ModifyDate = (date) => {
    var dateObj = new Date(date.toString());
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();

    var newdate = year + "-" + month + "-" + day;
    return newdate;
};


export default StringToTime;
export { ReadableDateTime, CurrentDate, ModifyDate, ReadableDate };